import React from 'react';
import './Settings.css';

function EmailTemplates({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <button className="back-button" onClick={onBack}>
                <span className="back-icon">←</span>
                <span>Back to HR Settings</span>
            </button>

            <div className="settings-component-content">
                <div className="settings-component-header">
                    <h1>📧 Email Templates</h1>
                    <p>Customize email templates for notifications</p>
                </div>

                <div className="settings-component-body">
                    <div className="settings-info-card">
                        <h3>Email Template Features</h3>
                        <p>This section will allow you to:</p>
                        <ul>
                            <li>Create custom email templates</li>
                            <li>Configure notification triggers</li>
                            <li>Manage template variables</li>
                            <li>Preview and test emails</li>
                        </ul>
                    </div>

                    <div className="settings-placeholder-message">
                        <span className="placeholder-icon">🚧</span>
                        <p>Email Templates configuration coming soon...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailTemplates;
